(function( $ ) {
    /* add pagination if needed */
    $('.slider-add-pages').append('<div class="swiper-pagination"></div>');

    /* add navigation if needed */
    $('.slider-add-navig').append('<div class="swiper-button swiper-button-next"></div><div class="swiper-button swiper-button-prev"></div>');

        
    $('.mega-slider, .slider-text').each(function (index) {
        if(!$('.swiper-pagination', this).length) {
            $(this).append('<div class="swiper-pagination"></div>');
        }
        if(!$('.swiper-button', this).length) {
            $(this).append('<div class="swiper-button swiper-button-next"></div><div class="swiper-button swiper-button-prev"></div>');
        }
    });


    /**
     * Homepage Showcase Fade
     */
    const fade_homepage = new Swiper('.showcase-slider__block_object', {
        spaceBetween:0,
        autoHeight: true,
        slidesPerView: 1,
        effect: "fade",
        watchOverflow: true,
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 7000,
        }
    });

    /**
     * Multimedia Slider
     */
    const swiper_media = new Swiper('.media-slider__block', {
        slidesPerView: 3,
        autoplay: {
            delay: 4000
        },
        breakpoints: {
            0: {
                slidesPerView: 1,               
            },
            360: {
                slidesPerView: 1,               
            },
            468: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            }
        }
    });

    /**
     * Stories slider
     */
    const swiper_stories = new Swiper('.stories-slider__block', {
        slidesPerView: 3,

        breakpoints: {
            360: {
                slidesPerView: 1,
            },
            468: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            }
        }
    });

    /**
     * History slider
     */

/*         $('.history-slider__block__items').each(function (index) {
            console.log($('label', this));
            $('.history-slider .swiper-pagination-bullets .swiper-pagination-bullet:eq( ' + index + ' )').append($('label', this).clone());
        }); */

        const swiper_history = new Swiper('.history-slider__block', {
            slidesPerView: 1,
            autoplay: {
                delay: 7000,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            on: {
                init: function () {
                    $('.history-slider__block__items').each(function (index) {
                        $('.history-slider .swiper-pagination-bullets .swiper-pagination-bullet:eq( ' + index + ' )').append($('label', this).clone());
                    });
                },
            }
        });

    /**
     * Mega slider
     */

        const swiper_mega = new Swiper('.mega-slider', {
            freeMode: false,
            slidesPerView: "auto",
            grabCursor: false,
            keyboard: {
              enabled: true,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
        });

        if($('.mega-slider').length) {
            jQuery(window).scroll(function (event) {
                manageSwiperAutoplay(swiper_mega);
            });

            $(window).resize(function () {
                manageSwiperAutoplay(swiper_mega);
            });
            // on load
            manageSwiperAutoplay(swiper_mega);
        }

        function manageSwiperAutoplay(swiper_entity) {
            if($(swiper_entity.el).visible(true, false, 'vertical')) {
                swiper_entity.autoplay.start();
            }
        }


/*         if($('.mega-slider').length) {
            jQuery(window).scroll(function (event) {
                manageSwiperMousewheel(swiper_mega);
            });

            $(window).resize(function () {
                manageSwiperMousewheel(swiper_mega);
            });
        }

        function manageSwiperMousewheel(swiper_entity) {
            var start_offset = -150;
            var end_offset = 0;
            var swiper_mega_position_start = swiper_entity.el.offsetTop + start_offset;
            var swiper_mega_position_end = swiper_entity.el.offsetTop + swiper_entity.height + end_offset;
            // console.log(swiper_mega_position_start, swiper_mega_position_end);

            // .swiper-wrapper

            var scrolltop = jQuery(window).scrollTop();
            var windowWidth = jQuery(window).width();
            
            if(windowWidth < 768) {
                swiper_entity.mousewheel.disable();
            } else {
                if( 
                    (scrolltop >= swiper_mega_position_start) && 
                    (scrolltop <= swiper_mega_position_end) 
                ) {
                    swiper_entity.mousewheel.enable();
                } else {
                    swiper_entity.mousewheel.disable();
                }
            }
        }
*/

    /**
     * Slider text
     */
        const swiper_text = new Swiper('.slider-text', {
            slidesPerView: "auto",
            centeredSlides: true,
            spaceBetween: 100,
            loop: false,
            initialSlide: 0,
            freeMode: false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
        });


        if($('.slider-text').length) {
            jQuery(window).scroll(function (event) {
                manageSwiperAutoplay(swiper_text);
            });

            $(window).resize(function () {
                manageSwiperAutoplay(swiper_text);
            });
            // on load
            manageSwiperAutoplay(swiper_text);
        }

})(jQuery)